import React, { useState } from 'react';
import Icon from '~/components/atom/Icon';
import JustificationContainer from '~/components/atom/JustificationContainer';
import Input from '~/components/molecule/Input';
import { FormBuilder_Event_Field } from '~/graphql/types';
import PointerSelector from '../PointerSelector';
import PointerRenderer from '../PointerRenderer';
import { issuesByPath } from '~/components/page/Forms/components/Builder/state/issues';
import { useRecoilValue } from 'recoil';
import { isNil } from 'ramda';

const text = {
  valueLabel: 'Waarde uit scherm',
  fieldLabel: 'Veld op event',
};
type Props = {
  field: FormBuilder_Event_Field;
  eventId: string;
  onSelect: (pointer: [string, string]) => void;
  pointer?: Array<string>;
  nodeId: string;
};

const FieldMapperRow: React.FCC<Props> = ({
  field,
  eventId,
  onSelect,
  pointer,
  nodeId,
}) => {
  const [showSelector, setShowSelector] = useState(false);
  const issues = useRecoilValue(issuesByPath([nodeId, field.key]));

  const issueMap = issues.reduce((acc, curr) => {
    if (curr && curr.blockKey && !isNil(curr.message)) {
      // field.key
      acc[curr?.blockKey] = curr.message;
    }

    return acc;
  }, {});

  return (
    <JustificationContainer align="center" width="100%" gap="m">
      <div
        style={{
          display: 'flex',
          width: '100%',
          position: 'relative',
        }}
      >
        {pointer ? (
          <PointerRenderer
            pointer={pointer}
            onFocus={() => setShowSelector(true)}
          />
        ) : (
          <Input
            externalErrors={issueMap[field.key] ? [issueMap[field.key]] : []}
            type="text"
            width="100%"
            label={text.valueLabel}
            onFocus={() => setShowSelector(true)}
            readOnly
          />
        )}
        {showSelector && (
          <PointerSelector
            eventId={eventId}
            field={field}
            onSelect={onSelect}
            onClose={() => {
              setShowSelector(false);
            }}
          />
        )}
      </div>
      <Icon name="arrowRight" style={{ fontSize: '2rem', marginTop: '1rem' }} />
      <Input
        type="text"
        value={field.name}
        disabled
        width="100%"
        label={text.fieldLabel}
      />
    </JustificationContainer>
  );
};

export default FieldMapperRow;
